<template>
  <div class="everyoneAsking">
    <div class="everyoneAsking-title">
      <img src="@/assets/images/home/everyone-asking-logo.png" alt="">
      <span>大家都在问</span>
    </div>
    <div class="everyoneAsking-cons">
      <div class="everyoneAsking-item" v-for="(item, index) in everyoneAskingList" :key="index"
           @click="$emit('search', item.label)">
        <img src="@/assets/images/home/everyone-asking-icon.png" alt="" class="icon-left">
        <span>{{ item && item.label }}</span>
        <img :src="item && item.icon" alt="" class="icon-right">
      </div>
    </div>
  </div>
</template>

<script>
import {dictionaryList} from '../../../api/api'

export default {
  data() {
    return {
      everyoneAskingList: []
    }
  },
  async created() {
    // 获取大家都要问列表
    await this.handleEveryoneAsking()
  },
  methods: {
    async handleEveryoneAsking() {
      // 获取大家都在问 字典表苏数据
      try {
        const res = await dictionaryList({typeCode: 'INTELLIGENT_EVERYONE_ASKING', dataStatus: 1})
        if (res.data.length > 0) {
          this.everyoneAskingList = res.data.map(item => {
            return {
              label: item.value,
              icon: require(`../../../assets/images/home/everyone_asking_${item.code.toLocaleLowerCase()}.png`)
            }
          })
        } else {
          this.everyoneAskingList = []
        }
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style scoped lang="less">
.everyoneAsking {
  display: flex;
  flex-direction: column;
  margin-top: 14px;
  padding: 0 14px;

  .everyoneAsking-title {
    display: flex;
    align-items: center;
    margin-bottom: 6px;

    img {
      width: 14px;
      margin-right: 5px;
    }

    span {
      color: #EB1700;
      font-family: PingFang HK, PingFang HK;
      font-weight: 600;
      font-size: 16px;
      height: 24px;
      line-height: 24px;
    }
  }

  .everyoneAsking-cons {
    .everyoneAsking-item {
      display: flex;

      & + .everyoneAsking-item {
        margin-top: 6px;
      }

      .icon-left {
        width: 8px;
        height: 8px;
        margin-right: 4px;
        margin-top: 8px;
      }

      .icon-right {
        height: 15px;
        margin-left: 3px;
        margin-top: 4px;
      }

      span {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        color: #000000;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/pageSearch/EveryoneAsking.vue